import { jsxs as f, jsx as t } from "react/jsx-runtime";
import r from "./station-select-search.module.less.js";
import { useTranslation as u } from "react-i18next";
import T from "../../../../../components/form-elements/components/input-skeleton-loader/input-skeleton-loader.js";
import { InputElementTopSection as A } from "../../../../../components/form-elements/components/input-element-top-section/input-element-top-section.js";
import { createFilterOptions as b } from "../../../../../node_modules/@mui/material/useAutocomplete/useAutocomplete.js";
import E from "../../../../../node_modules/@mui/material/Autocomplete/Autocomplete.js";
const h = ({
  availableStations: s,
  currentStation: p,
  onChooseStation: n,
  isLoading: a,
  isValid: l,
  className: m
}) => {
  const { t: i } = u(), c = (e, o) => {
    typeof n == "function" && o?.id !== void 0 && n(o.id);
  }, d = b({
    stringify: (e) => e?.filterString || ""
  });
  return /* @__PURE__ */ f("label", { className: `${r.wrapper} ${m}`, children: [
    /* @__PURE__ */ t(A, { label: i("TRAILER_RENTAL_STATION_SEARCH_LABEL") }),
    /* @__PURE__ */ t("div", { className: "space-mb-md", children: /* @__PURE__ */ t(
      E,
      {
        filterOptions: d,
        options: s ?? [],
        onChange: (e, o) => {
          c(e, o || {});
        },
        value: p,
        isOptionEqualToValue: (e, o) => e.id === o.id,
        ListboxProps: { className: [r.listbox, "body-base mb-0"].join(" ") },
        noOptionsText: /* @__PURE__ */ t("span", { className: [r.noOptions, "body-base mb-0"].join(" "), children: i("TRAILER_RENTAL_STATION_SEARCH_NO_OPTIONS") }),
        renderInput: (e) => a ? /* @__PURE__ */ t(T, {}) : /* @__PURE__ */ t("div", { ref: e.InputProps.ref, className: r.inputWrapper, children: /* @__PURE__ */ t(
          "input",
          {
            type: "text",
            ...e.inputProps,
            className: [r.input, l === !1 ? r.error : "", "body-base mb-0"].join(" "),
            placeholder: i("TRAILER_RENTAL_STATION_SEARCH_PLACEHOLDER")
          }
        ) })
      }
    ) })
  ] });
};
export {
  h as default
};
